import { ActivatedRoute, Router } from "@angular/router";
import { BaseAccountService } from "admin/baseLogin/BaseAccountService";
import { AppConstants } from "admin/utile/AppConstants";
import { RouterUtils } from "admin/_global/GlobalUtils";

export class BaseCompanyJoin
{
    enableCodeEntry: boolean = false;
    error: string;


    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected accountService: BaseAccountService,
        protected accountUrl: string)
    {
    }

    async joinCompany(): Promise<void> {
        const code: string = RouterUtils.GetParamByName(this.route, "code");

        if (!code) {
            this.enableCodeEntry = true;
            return;
        }

        let response;

        try {
            response = await this.accountService.joinCompany(code).toPromise();
        }
        catch (err) {
            console.error(err);
            this.error = err.Message;
            this.enableCodeEntry = true;
            return;
        }

        if (!response.Success) {
            this.error = response.Error;
            this.enableCodeEntry = true;
            return;
        }

        window.location.replace(AppConstants.baseUrl + this.accountUrl);
    }

    async joinCompanyWithCode(code: string): Promise<void> {
        if (!code) {
            this.error = "Code cannot be empty.";
            return;
        }

        let response;

        try {
            response = await this.accountService.joinCompany(code).toPromise();
        }
        catch (err) {
            console.error(err);
            this.error = err.Message;
            return;
        }

        if (!response.Success) {
            this.error = response.Error;
            return;
        }

        window.location.replace(AppConstants.baseUrl + this.accountUrl);
    }

    logout(): void {
        this.accountService.logout().toPromise().then(
            result => {
                if (result.Success) {
                    this.router.dispose();
                    window.location.replace(AppConstants.baseUrl + this.accountUrl);
                }
            },
            error => {

            }
        );
    }

    continue(): void {
        this.router.navigate(['/login']);
    }
}